import { ArrowDownAZ, ArrowUpAZ, ArrowDown01, ArrowUp01, ArrowDownWideNarrow, ArrowUpWideNarrow } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

// DEFECT-D-29: one small, reusable sort dropdown shared by every list screen that gained
// sorting — `fields` is `[{ value, label, type: "date"|"alpha"|"numeric" }]`; direction defaults
// flip sensibly per type (dates default newest-first, names default A→Z, amounts default
// highest-first) the first time a field is picked, but stay under the user's control after that.
const DEFAULT_DIR = { date: "desc", alpha: "asc", numeric: "desc" };

function iconFor(type, dir) {
  if (type === "alpha") return dir === "asc" ? <ArrowDownAZ size={13} /> : <ArrowUpAZ size={13} />;
  if (type === "numeric") return dir === "asc" ? <ArrowDown01 size={13} /> : <ArrowUp01 size={13} />;
  return dir === "asc" ? <ArrowUpWideNarrow size={13} /> : <ArrowDownWideNarrow size={13} />;
}

export function SortControl({ fields, sortBy, sortDir, onChange, testId }) {
  const current = fields.find((f) => f.value === sortBy) || fields[0];

  return (
    <div className="flex items-center gap-1.5">
      <Select
        value={sortBy}
        onValueChange={(value) => {
          const field = fields.find((f) => f.value === value);
          onChange(value, DEFAULT_DIR[field?.type] || "desc");
        }}
      >
        <SelectTrigger data-testid={testId} className="w-[168px] gap-1.5">
          <span className="flex items-center gap-1.5">{iconFor(current?.type, sortDir)} <SelectValue /></span>
        </SelectTrigger>
        <SelectContent>
          {fields.map((f) => <SelectItem key={f.value} value={f.value}>{f.label}</SelectItem>)}
        </SelectContent>
      </Select>
      <button
        data-testid={testId ? `${testId}-direction` : undefined}
        title={sortDir === "asc" ? "Ascending" : "Descending"}
        onClick={() => onChange(sortBy, sortDir === "asc" ? "desc" : "asc")}
        className="p-2 rounded-[8px] transition-colors hover:bg-black/5 scarlet-focusable"
        style={{ border: "1px solid var(--scarlet-hairline)", color: "var(--scarlet-text-secondary)" }}
      >
        {sortDir === "asc" ? "↑" : "↓"}
      </button>
    </div>
  );
}
